import { useLocale } from "@superweb/intl";

import { useV1ParkInfoGet } from "@fleet/api/fleet-forms";

import { useOperationIdContext } from "../ui";

import { searchParamTypes as t, useSearchParams } from "../router-new";

export const useBrand = () => {
  const locale = useLocale();

  const { sessionId } = useOperationIdContext();

  const [{ ref_id }] = useSearchParams({ ref_id: t.string });

  const { data: parkInfo } = useV1ParkInfoGet(
    {
      headers: {
        language: locale.toString(),
        "x-session-id": sessionId,
      },
      query: { ref_id: ref_id! },
    },
    {
      enabled: Boolean(ref_id),
    },
  );

  return parkInfo?.status !== 400 ? parkInfo?.data.brand : "";
};
